export default __webpack_public_path__ + "static/media/EM0333.34I-41676_-24948_0.01915743.jpg";